/* @generated */

// src/assets/ui-icon/line/scribble.tsx
import * as React from "react";
var ScribbleLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M17.554 13.813a3.395 3.395 0 0 0-4.187.931L10.5 18.029a1.246 1.246 0 0 1-.755.462c-.054.007-.107.01-.162.01H9.25A1.254 1.254 0 0 1 8 17.25c0-1.674 1.93-2.576 4.166-3.621a68.25 68.25 0 0 0 1.165-.554c.396-.195.787-.381 1.17-.563 2.827-1.345 5.5-2.614 5.5-5.455A3.06 3.06 0 0 0 16.944 4h-.186c-1.82 0-2.963 1.144-5.039 3.22-.53.529-1.024 1.047-1.487 1.532-1.35 1.413-2.623 2.75-3.339 2.75h-.19a1.204 1.204 0 0 1-.7-2.186L8.62 7.958l.088-.053a2.59 2.59 0 0 0 .663-3.569l-1.25.832a1.096 1.096 0 0 1-.245 1.486l-2.601 1.35-.071.042A2.704 2.704 0 0 0 6.704 13h.19c1.358 0 2.644-1.348 4.424-3.213.456-.477.941-.986 1.463-1.507 1.909-1.908 2.78-2.78 3.978-2.78h.186A1.557 1.557 0 0 1 18.5 7.056c0 1.8-1.765 2.73-4.643 4.1-.388.184-.785.373-1.188.57-.378.186-.76.365-1.139.542C9.058 13.424 6.5 14.62 6.5 17.25A2.755 2.755 0 0 0 9.25 20h.33c.119 0 .237-.008.354-.023a2.725 2.725 0 0 0 1.7-.97l2.868-3.283a2 2 0 0 1 2.18-.656A2.022 2.022 0 0 1 18 16.962V18h1.5v-1.038a3.5 3.5 0 0 0-1.946-3.149Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  ScribbleLine
};
